/**
 * Milestone object generated by Goal app.
 *
 * @typedef {Object} Milestone
 * @namespace
 *
 * @memberof module:Goal.Model.Entity
 *
 * @property {String} id The Milestone id.
 * @property {Integer} goal The numeric target goal for the milestone.
 * @property {String} label The textual label for the milestone.
 */
class Milestone {

	constructor(id, goal, label) {

		this.id = id;
		this.goal = goal;
		this.label = label;
	}
}

export default Milestone;